import { render, staticRenderFns } from "./setPwdDc.vue?vue&type=template&id=2cc241c8&scoped=true"
import script from "./setPwdDc.vue?vue&type=script&lang=js"
export * from "./setPwdDc.vue?vue&type=script&lang=js"
import style0 from "./setPwdDc.vue?vue&type=style&index=0&id=2cc241c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc241c8",
  null
  
)

export default component.exports